import { RetornoApi } from "app/api/types/RetornoApi";
import { ICidade } from "./ICidade";
import { IEndereco } from "./IEndereco";
import { IEstado } from "./IEstado";
import { ISegmento } from "./ISegmento";
import globalMU from "globalMU";
import { DadosGuiaClienteContract } from "app/components/pesquisa-cliente/dados-cliente/DadosCliente";

function ValidarInscricaoSuframa(inscricaoSuframa: string): string { // 462219

    // Function to check if a string is alphanumeric
    const verificarSePossuiLetra = (str) => {
      const regex = /[a-zA-Z]/;
      return regex.test(str);
    }
  
    const deixarSomenteNumeros = (str) => str.replace(/\D/g, '');
    
    if (!inscricaoSuframa) {
      return "";
    }
    
    const temLetras = verificarSePossuiLetra(inscricaoSuframa)
    if (temLetras) {
      return 'Não é permitido letras na Incrição Suframa!'
    }
    inscricaoSuframa = inscricaoSuframa?.trim()
    inscricaoSuframa = deixarSomenteNumeros(inscricaoSuframa);
 
    if (inscricaoSuframa.length !== 9 || inscricaoSuframa.startsWith('00')) {
      return 'Inscrição Suframa inválida!'
  }

  
  
    const lnDigitos = inscricaoSuframa.split('').map((d) => parseInt(d, 10));
    const lnSomaDosProdutosDosDigitos = lnDigitos.slice(0, 8).reduce((acc, digito, index) => {
      return acc + digito * (9 - index);
    }, 0);
  
    const lnRestoDivisaoSomaDosDigitos = lnSomaDosProdutosDosDigitos % 11;
  
    const lnDigitoVerificador =
      lnRestoDivisaoSomaDosDigitos <= 1 ? 0 : 11 - lnRestoDivisaoSomaDosDigitos;
  
    const isValid = lnDigitoVerificador === lnDigitos[8];
  
    return isValid ? "" : "Inscrição Suframa inválida!";
  }
  
  export default ValidarInscricaoSuframa;
  
export interface ICliente {
    Apelido?: string;
    Bairro?: string;
    Celular?: string;
    CelularObrigatorio?: boolean;
    Cep?: string;
    Cidade?: ICidade
    Codigo?: number;
    CodigoCidade?: number;
    CodigoEndereco?: number;
    CodigoEstado?: number;
    CodigoSegmento?: number;
    CodigoTipoPessoa?: number;
	  TipoPessoa?: string; // 441453
    PessoaJuridica?: boolean,
    CodigoVendedorRelacionado?: number;
    CodVendRelacionado?: string;
    NomeVendedorRelacionado?: string;
    PossuiAtendimentoNaoLido?: boolean;
    PossuiAcompanhamento?: boolean;
    PossuiCreditos?: boolean;
    ComplementoEndereco?: string;
    Contato?: string;
    Contribuinte?: boolean;
    CpfCnpj?: string;
    DataNascimento?: any;
    DadosGuiaCliente?: DadosGuiaClienteContract;
    Email?: string;
    EmailObrigatorio?: boolean;
    EmailPixAPrazo?: string // 414608 pixPrazo
    EmailPixAPrazoOriginal?: string // 414608 pixPrazo
    AtualizarEmailPixAPrazo?: boolean // 414608 pixPrazo
    ClassificadoComoFilial?: boolean; // 431546 - 430877 
    Endereco?: string;
    Enderecos?: IEndereco[];
    Estado?: IEstado
    InscricaoEstadual?: string;
    InscricaoSuframa?: string;
    ItensFichaCrediario?: {
        CodigoDadoAdicional?: number;
        TipoSuperior?: number,
        Data?: any;
        Descricao?: string;
        Texto?: string;
        TextoLongo?: string;
        Tipo?: any;
        Valor?: number;
        UserMessage?: string;
        Transforming?: boolean
    }[];
    Nome?: string;
    NomeCidade?: string;
    NumeroEndereco?: string;
    PermitirEditarEndereco?: boolean;
    RazaoSocial?: string;
    Referencia?: string;
    Representante?: boolean;
    Segmento?: ISegmento;
    SegmentoObrigatorio?: boolean;
    SiglaUf?: string;
    Telefone?: string;
    TelefoneObrigatorio?: boolean;
    VendedorRelacionado?: string;
    VendedorRelacionadoObrigatorio?: boolean;
    Classificacoes?: number[];
    CodigoClassificacao?: number;
    NomeProfissao?: string;
    TipoNumeroRegistroProfissional?: string;
    NumeroNitPisPasep?: string;
    DadosAdicionais?: any[];
    ClienteMais?: boolean;
    NomeDadoAdicionalClienteMais?: string;
    ReceberNotificacaoWhatsapp?: boolean; // 447400
    ReceberNotificacaoEmail?: boolean; // 447400
    UserMessage?: string;
    Transforming?: boolean;
    OrcamentoVenda?: boolean;
    SaldoCashbackCliente?: number
    ValidadeCashbackCliente?: string,
    ValorCashbackUtilizado?: number,
    Estados?: IEstado;
    UsuarioPermitidoAlterarVendedorRelacionado?: boolean;
    existeCupomDescontoParaCliente?: boolean;
    ClienteAssociado?: string;

    //////
    HasErrors?: boolean,
    ErrorLevel?: string,
    //////
}